module.exports = __webpack_public_path__ + "img/Excavator-Outline.91114ce5.png";